import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  Input,
  FormLabel,
  useToast,
} from "@chakra-ui/react";
import React, { useState } from "react";

import Notification from "../../services/Notification";

import Reachout from "../../services/Reachout";

// import { AiFillLock, AiFillUnlock } from "react-icons/ai";

export default function DateTimeModal({
  isOpen,
  onClose,
  func = null,
  id,
  templateId,
  type,
  variableValues,
  scheduledDate = "",
  scheduledTime = "",
}: any) {
  const [date, setDate] = useState(scheduledDate || "");
  const [time, setTime] = useState(scheduledTime || "");
  const initialRef = React.useRef(null);

  const toast = useToast();

  const updateReachout = async (send_mode: any) => {
    if (type === "email") {
      await Notification.updateEmailTemplate(templateId, variableValues).then(
        (res) => {}
      );
    }

    await Reachout.updateReachoutNotification(id, date, time, send_mode).then(
      (res) => {
        toast({
          position: "top",
          title: "Reachout Scheduled.",
          description: "Reachout is scheduled to sent to users successfully.",
          status: "success",
          duration: 1000,
          isClosable: true,
        });
        func?.();
      }
    );
  };

  return (
    <>
      <Modal initialFocusRef={initialRef} isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Schedule</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <FormControl mt={4}>
              <FormLabel mt={4}>Set Date</FormLabel>
              <Input
                value={date}
                type="date"
                ref={initialRef}
                onChange={(e) => setDate(e.target.value)}
              />
              <FormLabel mt={4}>Set Time</FormLabel>
            </FormControl>
            <FormControl mt={4}>
              <Input
                value={time}
                type="time"
                ref={initialRef}
                onChange={(e) => setTime(e.target.value)}
              />
            </FormControl>
          </ModalBody>

          <ModalFooter>
            <Button
              bgColor="#327171"
              color={"white"}
              mr={3}
              onClick={() => {
                updateReachout("user");
                onClose();
              }}
            >
              Submit
            </Button>
            <Button bgColor="red" color={"white"} onClick={onClose}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
